<template>
  <div
    class="
      w-full
      flex
      flex-col
      items-center
      justify-center
      text-white
      p-16
    "
    v-bind:style="{ background: `hsl(${picked.h}, ${picked.s}%, ${picked.l}%)`}"
  >
    <h1 class="text-shadow mb-6">
      <small>HSL:</small> {{ picked.h }} {{ picked.s }} {{ picked.l }}
    </h1>
    <v-button
      :click="() => $emit('copy', picked)"
      text="Copy To Clipboard"
    ></v-button>
  </div>
</template>

<script>
import Button from './Button.vue';

export default {
  name: 'Picked',
  props: [
    'picked',
  ],
  components: {
    'v-button': Button,
  },
};
</script>
